<template>
  <v-app>
    <v-card>
      <v-card-text class="mt-5">

        <v-alert class="alert-danger mb-10" v-if="data.reject_text && data.status == 'pending'" border="bottom" colored-border
                 type="error" elevation="2">
          <h2>دلایل قبلی رد.</h2>
          <br/>
          <h4 v-for="(x,i) in data.reject_text.split('\n')">
            {{i + 1}} : {{x}}
          </h4>
        </v-alert>

        <v-row  class="justify-content-end">
          <v-btn class="btn-update" @click="openUserBillboards()">
            <v-icon size="25">mdi-account-box</v-icon>
            مشاهده دیگر بیلبورد های این کاربر
          </v-btn>
        </v-row>

        <v-row>
          <v-select   class="m-1" item-text="name" v-model="data.billboard_place" label="موقعیت بیلبورد" :items="centerItems" :loading="!centerItems.length" return-object outlined auto-select-first></v-select>
          <v-autocomplete class="m-1" v-model="data.type" :items="data.billboard_place ? data.billboard_place.types : []"
                          item-text="name" item-value="id" :disabled="!data.billboard_place || data.status == 'pending'"
                          outlined hide-no-data auto-select-first label="نوع" :error-messages="errors['type']">
          </v-autocomplete>


          <v-text-field   class="m-1" label="مدت اجاره (روز) " v-model="data.rental_period"
                        :rules="rules.mosabatMokhalefSefr" type="number" :error-messages="errors['rental_period']" outlined>
          </v-text-field>
        </v-row>
        <v-row>
          <v-text-field   class="m-1" label="طول" v-model="data.dimensions[0]" :rules="rules.mosabatMokhalefSefr"
                        type="number" outlined :error-messages="errors['dimensions.0']"></v-text-field>

          <v-text-field   class="m-1" label="عرض" v-model="data.dimensions[1]" :rules="rules.mosabatMokhalefSefr"
                        type="number" :error-messages="errors['dimensions.1']" outlined></v-text-field>

          <v-text-field   class="m-1" label="متراژ" v-model="data.meterage" :rules="rules.mosabatMokhalefSefr"
                        type="number" :error-messages="errors['meterage']" outlined></v-text-field>

        </v-row>

        <hr>

        <p class="mt-2">مبلغ اجاره : </p>
        <v-select   v-model="data.rentType" :items="data.rentTypes" item-text="name" item-value="value"
                  label="شیوه اجاره را مشخص کنید" dense outlined></v-select>
        <v-row v-if="data.rentType == 'amount'" class="justify-content-center">
          <v-text-field    class="m-1" style="max-width: 30rem" label="مبلغ اجاره" v-model="data.rent[0]"
                        :rules="rules.mosabatMokhalefSefr" append-icon="mdi-currency-rial" type="number"
                        :error-messages="errors['rent']" outlined></v-text-field>
        </v-row>


        <v-row v-if="data.rentType == 'season'">
          <v-text-field    class="m-1" append-icon="mdi-currency-rial" label="بهار" v-model="data.rent[0]"
                        :rules="rules.mosabatMokhalefSefr" type="number" :error-messages="errors['rent.0']" outlined></v-text-field>


          <v-text-field    class="m-1" append-icon="mdi-currency-rial" label="تابستان" v-model="data.rent[1]"
                        :rules="rules.mosabatMokhalefSefr" :error-messages="errors['rent.1']" type="number" outlined></v-text-field>


          <v-text-field    class="m-1" append-icon="mdi-currency-rial" label="پاییز" v-model="data.rent[2]"
                        :rules="rules.mosabatMokhalefSefr" :error-messages="errors['rent.2']" type="number" outlined></v-text-field>


          <v-text-field    class="m-1" append-icon="mdi-currency-rial" label="زمستان" v-model="data.rent[3]"
                        :rules="rules.mosabatMokhalefSefr" type="number" :error-messages="errors['rent.3']" outlined></v-text-field>

        </v-row>
        <v-row v-if="data.rentType == 'moon'">
          <v-text-field    class="m-1" append-icon="mdi-currency-rial" label="فروردین" v-model="data.rent[0]"
                        :rules="rules.mosabatMokhalefSefr" type="number" :error-messages="errors['rent.0']" outlined></v-text-field>


          <v-text-field    class="m-1" append-icon="mdi-currency-rial" label="اردیبهشت" v-model="data.rent[1]"
                        :rules="rules.mosabatMokhalefSefr" :error-messages="errors['rent.1']" type="number" outlined></v-text-field>


          <v-text-field    class="m-1" append-icon="mdi-currency-rial" label="خرداد" v-model="data.rent[2]"
                        :rules="rules.mosabatMokhalefSefr" :error-messages="errors['rent.2']" type="number" outlined></v-text-field>


          <v-text-field    class="m-1" append-icon="mdi-currency-rial" label="تیر" v-model="data.rent[3]"
                        :rules="rules.mosabatMokhalefSefr" type="number" :error-messages="errors['rent.3']" outlined></v-text-field>


          <v-text-field    class="m-1" append-icon="mdi-currency-rial" label="مرداد" v-model="data.rent[4]"
                        :rules="rules.mosabatMokhalefSefr" type="number" :error-messages="errors['rent.4']" outlined></v-text-field>



          <v-text-field    class="m-1" append-icon="mdi-currency-rial" label="شهریور" v-model="data.rent[5]"
                        :error-messages="errors['rent.5']" :rules="rules.mosabatMokhalefSefr" type="number" outlined></v-text-field>


          <v-text-field    class="m-1" append-icon="mdi-currency-rial" label="مهر" v-model="data.rent[6]"
                        :rules="rules.mosabatMokhalefSefr" :error-messages="errors['rent.6']" type="number" outlined></v-text-field>


          <v-text-field    class="m-1" append-icon="mdi-currency-rial" label="آبان" v-model="data.rent[7]"
                        :rules="rules.mosabatMokhalefSefr" :error-messages="errors['rent.7']" type="number" outlined></v-text-field>


          <v-text-field    class="m-1" append-icon="mdi-currency-rial" label="آذر" v-model="data.rent[8]"
                        :error-messages="errors['rent.8']" :rules="rules.mosabatMokhalefSefr" type="number" outlined></v-text-field>


          <v-text-field    class="m-1" append-icon="mdi-currency-rial" label="دی" v-model="data.rent[9]"
                        :error-messages="errors['rent.9']" :rules="rules.mosabatMokhalefSefr" type="number" outlined></v-text-field>


          <v-text-field    class="m-1" append-icon="mdi-currency-rial" label="بهمن" v-model="data.rent[10]"
                        :error-messages="errors['rent.10']" :rules="rules.mosabatMokhalefSefr" type="number" outlined>
          </v-text-field>


          <v-text-field    class="m-1" append-icon="mdi-currency-rial" label="اسفند" v-model="data.rent[11]"
                        :error-messages="errors['rent.11']" :rules="rules.mosabatMokhalefSefr" type="number" outlined>
          </v-text-field>

        </v-row>

        <hr/>

        <v-row class="flex-column">
          <p class="my-3">
            عکس های بیلبورد
          </p>
          <div class="imageSelectorContainer w-100" @click="updateClick">
            <ImagePicker v-model="data.images" addImagesLabel="افزودن عکس" clearImagesLabel="حذف تمامی عکس ها" :max="10"
                         :maxSize="1000000" exceedMaxImagesError="حد اکثر تعداد عکس 10 عدد میباشد"
                         invalidFileTypeError="فرمت وارد شده باید jpeg یا jpg یا png باشد"
                          
                         fileSizeError="حد اکثر حجم فایل ها 1 مگ میباشد.">
              <v-flex xs4 md3 class="justify-content-center flex-column align-items-center text-center">
                <img src="media/empty/empty-list.png" style="width:200px; height:140px">
                <p class="text-center">عکسی انتخاب کنید</p>
              </v-flex>
            </ImagePicker>
          </div>
        </v-row>
        <hr>


        <v-row>
          <v-btn color="indigo" outlined class="text-white col-md-12 inputs my-2" :loading="video.isSelecting"  
                 @click="handleFileImport">
            <v-icon>mdi-briefcase-upload</v-icon>
            آپلود ویدیو
          </v-btn>
          <input ref="uploader" class="d-none" type="file" @change="onFileChanged">
          <p class="text-danger" v-if="errors['video']">{{ errors['video'] }}</p>
        </v-row>

        <v-row class="justify-content-center mt-2 mb-4" v-if="data.video_url">
          <p class="text-center mt-2 mb-4">
            فایل آپلود شده را میتوانید از
            <a target="_blank" :href="appUrl + '/storage/' + (this.data.video_url ? data.video_url : '')">
              اینجا دانلود
            </a>
            کنید
          </p>
        </v-row>




        <hr />

        <v-row class="flex-column">
          <p class="mt-2">مکان روی نقشه : </p>
          <l-map style="height: 500px" :zoom="mapData.zoom"  
                 :center="mapData.center ? mapData.center : [32.64433, 51.65923]" :options="mapData.mapOptions"
                 @click="clickedOnMap">
            <l-tile-layer :url="mapData.url" />
            <l-marker :lat-lng="data.location" v-if="data.location" />
          </l-map>
          <p class="text-danger" v-if="errors['location']">{{ errors['location'] }}</p>
          <p class="text-danger" v-if="errors['location.0']">{{ errors['location.0'] }}</p>
          <p class="text-danger" v-if="errors['location.1']">{{ errors['location.1'] }}</p>
        </v-row>

        <hr class="my-5"/>

        <v-row class="flex-column">
          <v-combobox  
                      class="m-1"
                      outlined
                      name="input-7-4"
                      label="آدرس"
                      :rules="rules.address"
                      v-model="data.address"
                      :items="addressSearch.items"
                      :search-input.sync="addressSearch.text"
                      :error-messages="errors['address']"></v-combobox>
          <div class="d-flex flex-column">

            <v-btn  class="btn-show" :disabled="!data.location || data.status == 'pending'" @click="selectAddressWithLocation">وارد کردن ادرس بر اساس مکان انتخابی روی نقشه</v-btn>

          </div>

        </v-row>

        <hr />

        <hr>
        <v-row>
          <v-textarea class="m-1" outlined name="input-7-4" label="توضیحات" v-model="data.description"
                       
                      :rules="rules.address" :error-messages="errors['description']"></v-textarea>
        </v-row>

        <v-row  class="justify-content-end">
          <v-btn class="btn-update" :disabled="!isValid" @click="update()" >
            <v-icon size="25">mdi-reload</v-icon>
            به روز رسانی
          </v-btn>
          <v-select  label="وضعیت" v-model="data.status" :items="statuses" item-value="value" item-text="text" outlined></v-select>
        </v-row>

        <v-row>
          <v-textarea v-if="data.status == 'reject'" class="m-1" outlined name="input-7-4" label="دلایل رد" v-model="data.reject_text"

                      :rules="rules.text" :error-messages="errors['reject_text']"></v-textarea>
        </v-row>

      </v-card-text>
    </v-card>
  </v-app>



</template>

<script>
import { latLng } from "leaflet";
import { ImagePicker, imageUploadingStates } from "@nagoos/vue-image-picker"

export default {
  name: "create",
  components: { ImagePicker, imageUploadingStates },
  data() {
    return {
      addressSearch:{
        items : [],
        text : ""
      },
      appUrl : process.env.VUE_APP_API_URL,
      statuses :[
        {
          text: "تایید",
          value: "active",
        },
        {
          text: "رد",
          value: "reject"
        },
        {
          text: "غیر فعال",
          value: "disable"
        },
        {
            text : "در انتظار تایید",
            value: "pending"
        }
      ],
      data: {
        status : "",
        video_url: null,
        billboard_place : "",
        address: "",
        location: null,
        dimensions: [0, 0],
        images: [],
        video: null,
        meterage: 0,
        rentTypes: [
          {
            name: "توافقی",
            value: "agreement"
          }, {
            name: "مبلغ اجاره",
            value: "amount"
          }, {
            name: "تفکیک هر فصل",
            value: "season"
          }, {
            name: "تفکیک هر ماه",
            value: "moon"
          }
        ],
        rentType: "agreement",
        rent: [
          0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0
        ],
        rental_period: 0,
        description: "",
        type: 0,
      },

      mapData: {
        zoom: 13,
        center: latLng(32.64433, 51.65923),
        url: 'https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png',
        currentZoom: 11.5,
        currentCenter: latLng(47.41322, -1.219482),
        mapOptions: {
          zoomSnap: 0.5
        },
      },

      video: {
        isSelecting: false,
      },

      rules: {
        text : [
          v => !!(v ?? "").trim() || "لطفا مقداری وارد کنید."
        ],
        mosabatMokhalefSefr: [
          v => Math.sign(v) === 1|| v == 0 || "مقدار وارد شده باید عدد و بزرگتر از 0 باشد."
        ],
        address: [
          v => !((v ?? "").length < 4 || (v ?? "").length > 5000) || 'مقدار وارد شده باید بزرگتر از 4 کاراکتر و حد اکثر 5 هزار کاراکتر باشد'
        ]
      },

      typeSuggest: [],

      showSuggest: [],
      typeSearch: "",
      errors: [],
      isOkey: true,
      billId: null,
      billData: [],
      billImages: [],
      once : false,
      centerItems : []
    }

  },
  created() {


  },
  mounted() {
    this.getSuggestionType();
    window.document.querySelector(".imageSelectorContainer button.success").classList.add('submit-btn')
    window.document.querySelector(".imageSelectorContainer button.red--text").classList.add('btn-delete')
  },
  watch: {
    // typeSearch() {
    //   for (let i of this.typeSuggest) {
    //     if (i.name === (this.typeSearch ?? "").trim()) {
    //       this.data.type = i.id;
    //       return;
    //     }
    //   }
    //   this.showSuggest = []
    //   if (this.typeSearch) {
    //     this.showSuggest.push({
    //       name: this.typeSearch,
    //       id: this.typeSearch.trim()
    //     })
    //     this.data.type = this.showSuggest[0].id;
    //   }
    //   this.showSuggest = [...this.showSuggest, ...this.typeSuggest];
    // }
  },
  computed: {

    isValid() {
      let flag = true;
      if (this.billId) {
        flag = true
        return flag
      } else {
        flag &&= Math.sign(this.data.dimensions[0]) === 1;

        flag &&= Math.sign(this.data.dimensions[1]) === 1;

        flag &&= Math.sign(this.data.meterage) === 1;

        flag &&= Math.sign(this.data.rental_period) === 1;

        switch (this.data.rentType) {
          case "amount":
            flag &&= Math.sign(this.data.rent[0]) === 1;
            break;
          case "season":
            flag &&= Math.sign(this.data.rent[0]) === 1;
            flag &&= Math.sign(this.data.rent[1]) === 1;
            flag &&= Math.sign(this.data.rent[2]) === 1;
            flag &&= Math.sign(this.data.rent[3]) === 1;
            break;
          case "moon":
            flag &&= Math.sign(this.data.rent[0]) === 1;
            flag &&= Math.sign(this.data.rent[1]) === 1;
            flag &&= Math.sign(this.data.rent[2]) === 1;
            flag &&= Math.sign(this.data.rent[3]) === 1;
            flag &&= Math.sign(this.data.rent[4]) === 1;
            flag &&= Math.sign(this.data.rent[5]) === 1;
            flag &&= Math.sign(this.data.rent[6]) === 1;
            flag &&= Math.sign(this.data.rent[7]) === 1;
            flag &&= Math.sign(this.data.rent[8]) === 1;
            flag &&= Math.sign(this.data.rent[9]) === 1;
            flag &&= Math.sign(this.data.rent[10]) === 1;
            flag &&= Math.sign(this.data.rent[11]) === 1;
            break;
        }

        flag &&= this.isValidTextAddress(this.data.address);

        flag &&= this.isValidTextAddress(this.data.description);

        flag &&= this.isValidTextAddress(this.data.billboard_place);

        flag &&= this.data.location;

        flag &&= this.data.type;

        flag &&= this.data.status;

        if (this.data.status === 'reject'){
          flag &&= this.data.reject_text;
        }

        return flag;
      }
    },

  },
  methods: {
    openUserBillboards(){
      window.open(this.$router.resolve({name: 'billboardUserList' , params:{id: this.data.user_id}}).href, '_blank');
    },
    fetch(){
      if (this.$route.params.id) {
        this.$modal.showLoading();
        this.billId = this.$route.params.id
        this.requestApiGet('billboard/admin/' + this.$route.params.id)
            .then(res => {
              let billData = res.data.data

              for (let i = 0; i < this.centerItems.length; i++) {
                if (this.centerItems[i].id === billData.place_id){
                  this.data.billboard_place = this.centerItems[i];
                  break;
                }
              }

              console.log("filter " , this.centerItems.filter((a) => {
                return a.id === billData.place_id;
              })[0]);


              console.log(billData.place_id)
              this.data.dimensions[0] = billData.dimensions[0]
              this.data.dimensions[1] = billData.dimensions[1]
              this.data.user_id = billData.user_id

              this.data.reject_text = billData.reject_text;
              this.data.status = billData.status;

              if (billData.meterage) {
                this.data.meterage = billData.meterage
              }

              this.data.address = billData.address
              this.data.video_url = billData.video;

              this.data.type = billData.type

              this.data.rental_period = billData.rental_period

              if (billData.location) {
                this.data.location = billData.location
                this.mapData.center = billData.location
              }

              if (billData.rent.type == 'agreement') {
                this.data.rentType = billData.rent.type
              } else if (billData.rent.type == 'amount') {
                this.data.rentType = billData.rent.type
                this.data.rent[0] = billData.rent.value
              } else if (billData.rent.type == 'season') {
                this.data.rentType = billData.rent.type
                for (let k = 0; k < billData.rent.value.length; k++) {
                  this.data.rent[k] = billData.rent.value[k]
                }
              } else if (billData.rent.type == 'moon') {
                this.data.rentType = billData.rent.type
                for (let k = 0; k < billData.rent.value.length; k++) {
                  this.data.rent[k] = billData.rent.value[k]
                }
              }


              if (billData.images) {
                for (let j = 0; j < billData.images.length; j++) {
                  this.billImages.push ({
                    imageFile: billData.images[j],
                    imageURL: process.env.VUE_APP_API_URL + '/storage/' + billData.images[j]
                  })
                  this.data.images[j] = this.billImages[j]
                }
              }
              this.data.video = billData.video
              this.data.description = billData.description


            })
            .catch(err => console.log(err))
            .finally(()=>{
              this.$modal.hideLoading();
            })
      }
    },
    selectAddressWithLocation(){
      this.$modal.showLoading()
      this.requestApiGet('map/address' , {lat: this.data.location.lat ?? this.data.location[0] , lon: this.data.location.lng ?? this.data.location[1] })
          .then((res)=>{
            console.log(res.data.address , res.data);
            this.data.address = res.data.address;
          })
          .catch((e)=>{
            this.$toast.error('خطا در دریافت ادرس بر اساس موقعیت مکانی');
          }).finally(()=>{
        this.$modal.hideLoading();
      })
    },
    updateClick() {
      if(this.billImages.length != 0 && this.once == false) {
        this.data.images = []
        this.once = true
      }
    },
    update() {
      let data = new FormData();
      data.append('address', this.data.address)
      data.append('status', this.data.status)
      data.append('reject_text', this.data.reject_text)

      if (this.data.location.lat || this.data.location.lng) {
        data.append('location[0]', this.data.location.lat)
        data.append('location[1]', this.data.location.lng)
        console.log('lat and lang exist')
      } else {
        data.append('location[0]', this.data.location[0])
        data.append('location[1]', this.data.location[1])
        console.log('lat and lag dont exist')
      }

      data.append('meterage', this.data.meterage)
      data.append('status', this.data.status)
      data.append('reject_text', this.data.reject_text)

      data.append('description', this.data.description)

      data.append('type', this.data.type)

      data.append('rental_period', this.data.rental_period)

      data.append('dimensions[0]', this.data.dimensions[0])
      data.append('dimensions[1]', this.data.dimensions[1])

      data.append('billboard_place', this.data.billboard_place)


      data.append('rent[type]', this.data.rentType)

      switch (this.data.rentType) {
        case "amount":
          data.append('rent[value][0]', this.data.rent[0])
          break;

        case "season":
          data.append('rent[value][0]', this.data.rent[0])
          data.append('rent[value][1]', this.data.rent[1])
          data.append('rent[value][2]', this.data.rent[2])
          data.append('rent[value][3]', this.data.rent[3])
          break;

        case "moon":
          data.append('rent[value][0]', this.data.rent[0])
          data.append('rent[value][1]', this.data.rent[1])
          data.append('rent[value][2]', this.data.rent[2])
          data.append('rent[value][3]', this.data.rent[3])
          data.append('rent[value][4]', this.data.rent[4])
          data.append('rent[value][5]', this.data.rent[5])
          data.append('rent[value][6]', this.data.rent[6])
          data.append('rent[value][7]', this.data.rent[7])
          data.append('rent[value][8]', this.data.rent[8])
          data.append('rent[value][9]', this.data.rent[9])
          data.append('rent[value][10]', this.data.rent[10])
          data.append('rent[value][11]', this.data.rent[11])
          break;
      }
      console.log(this.selectedFile)
      if (this.selectedFile != undefined) {
        console.log('step 1')
        const { maxSize } = this
        let vidSize = this.selectedFile.vidSize / maxSize / maxSize
        console.log('step 2', this.selectedFile)
        if (!this.selectedFile.type.match('video.*')) {
          // check whether the upload is an video
          this.$toast.error('فرمت فایل انتخابی صحیح نیست.')
          this.isOkey = false
        } else if (vidSize > 10) {
          // check whether the size is greater than the size limit
          this.$toast.error('حجم فایل انتخابی نباید بیش از ۱۰ مگابایت باشد.')
          this.isOkey = false
        } else {
          this.data.video = this.selectedFile
          console.log('step 3')
          data.append('video', this.data.video)
        }
      }
      console.log('step 4')
      if (this.data.images && this.data.images.length && this.data.images.key != undefined) {
        for (let img of this.data.images) {
          const { maxSize } = this
          let imgSize = img.imageFile.imgSize / maxSize / maxSize
          console.log('step 5')
          if (!img.imageFile.type.match('image.*')) {
            // check whether the upload is an image
            this.$toast.error('فرمت فایل انتخابی صحیح نیست.')
            console.log('step 6')
          } else if (imgSize > 1) {
            // check whether the size is greater than the size limit
            this.$toast.error('حجم فایل انتخابی نباید بیش از ۱ مگابایت باشد.')
          } else {
            data.append('images[]', img.imageFile);
          }
        }
      } else if (this.data.images && this.data.images.length) {
        for (let img of this.data.images) {
          data.append('images[]', img.imageFile);
        }
      }

      if (this.isOkey == false) {
        this.$toast.error('لطفا فایل ویدیویی مناسب آپلود نمایید.')
      } else {
        this.$modal.showLoading();
        this.requestApiPost(`billboard/admin/${this.billId}`, data)
            .then((res) => {
              console.log(res)
              if (res.status && res.status == 200) {
                this.$toast.success('با موفقیت ثبت شد.')
                this.goto('billboard-list')
              } else {
                this.$toast.warning('لطفا مجددا تلاش کنید')
              }
            })
            .catch((e) => {
              this.$toast.error('خطا در ثبت')
              console.log(e)
              this.errors = e.response.data.errors
            })
            .finally(() => {
              this.$modal.hideLoading();
            })
      }
    },
    submit() {
      let data = new FormData();
      data.append('address', this.data.address)

      data.append('location[0]', this.data.location.lat)
      data.append('location[1]', this.data.location.lng)

      data.append('meterage', this.data.meterage)

      data.append('description', this.data.description)

      data.append('type', this.data.type)

      data.append('rental_period', this.data.rental_period)

      data.append('dimensions[0]', this.data.dimensions[0])
      data.append('dimensions[1]', this.data.dimensions[1])

      data.append('billboard_place', this.data.billboard_place)

      data.append('rent[type]', this.data.rentType)

      switch (this.data.rentType) {
        case "amount":
          data.append('rent[value][0]', this.data.rent[0])
          break;

        case "season":
          data.append('rent[value][0]', this.data.rent[0])
          data.append('rent[value][1]', this.data.rent[1])
          data.append('rent[value][2]', this.data.rent[2])
          data.append('rent[value][3]', this.data.rent[3])
          break;

        case "moon":
          data.append('rent[value][0]', this.data.rent[0])
          data.append('rent[value][1]', this.data.rent[1])
          data.append('rent[value][2]', this.data.rent[2])
          data.append('rent[value][3]', this.data.rent[3])
          data.append('rent[value][4]', this.data.rent[4])
          data.append('rent[value][5]', this.data.rent[5])
          data.append('rent[value][6]', this.data.rent[6])
          data.append('rent[value][7]', this.data.rent[7])
          data.append('rent[value][8]', this.data.rent[8])
          data.append('rent[value][9]', this.data.rent[9])
          data.append('rent[value][10]', this.data.rent[10])
          data.append('rent[value][11]', this.data.rent[11])
          break;
      }

      if (this.selectedFile) {
        const { maxSize } = this
        let vidSize = this.selectedFile.vidSize / maxSize / maxSize
        if (!this.selectedFile.type.match('video.*')) {
          // check whether the upload is an video
          this.$toast.error('فرمت فایل انتخابی صحیح نیست.')
          this.isOkey = false
        } else if (vidSize > 10) {
          // check whether the size is greater than the size limit
          this.$toast.error('حجم فایل انتخابی نباید بیش از ۱۰ مگابایت باشد.')
          this.isOkey = false
        } else {
          this.data.video = this.selectedFile
          data.append('video', this.data.video)
        }
      }

      if (this.data.images && this.data.images.length) {
        console.log(this.data.images)
        for (let img of this.data.images) {
          const { maxSize } = this
          let imgSize = img.imageFile.imgSize / maxSize / maxSize
          if (!img.imageFile.type.match('image.*')) {
            // check whether the upload is an image
            this.$toast.error('فرمت فایل انتخابی صحیح نیست.')
          } else if (imgSize > 1) {
            // check whether the size is greater than the size limit
            this.$toast.error('حجم فایل انتخابی نباید بیش از ۱ مگابایت باشد.')
          } else {
            data.append('images[]', img.imageFile);
          }
        }
      }

      if (this.isOkey == false) {
        this.$toast.error('لطفا فایل ویدیویی مناسب آپلود نمایید.')
      } else {
        this.$modal.showLoading();
        this.requestApiPost('billboard', data)
            .then((res) => {
              this.goto('billboard-register')
              this.$toast.success('با موفقیت ثبت شد.')
            })
            .catch((e) => {
              console.log(e)
              this.errors = e.response.errors
              this.$toast.error('خطا در ثبت')
            })
            .finally(() => {
              this.$modal.hideLoading();
            })
      }

    },
    isValidTextAddress(v) {
      return !((v ?? "").length < 4 || (v ?? "").length > 5000)
    },
    clickedOnMap(e) {
      this.data.location = e.latlng;
      console.log(this.data.location)
    },
    getSuggestionType() {
      this.requestApiGet('places?withType=1')
          .then((res) => {
            this.centerItems = res.data.data;
            this.fetch();
          })
    },
    handleFileImport() {
      this.video.isSelecting = true;
      // After obtaining the focus when closing the FilePicker, return the button state to normal
      window.addEventListener('focus', () => {
        this.video.isSelecting = false
      }, { once: true });
      // Trigger click on the FileInput
      this.$refs.uploader.click();
    },
    onFileChanged(e) {
      const { maxSize } = this
      this.selectedFile = e.target.files[0];
      // Do whatever you need with the file, liek reading it with FileReader
      let size = this.selectedFile.size / maxSize / maxSize
      console.log('video 1')
      console.log(this.selectedFile, '2')
      if (!this.selectedFile.type.match('video.*')) {
        // check whether the upload is an image
        this.$toast.error('فرمت فایل انتخابی صحیح نیست.')
        console.log('video 2')
      } else if (size > 10) {
        // check whether the size is greater than the size limit
        this.$toast.error('حجم فایل انتخابی نباید بیش از ۱۰ مگابایت باشد.')
      }
    },

  }
}
</script>

<style>
.imageSelectorContainer .layout {
  justify-content: center !important;
}

.imageSelectorContainer button.success{
  height: 3rem;
  background-color: transparent !important;
}

.imageSelectorContainer button.success:hover{
  color: white !important;
}

.imageSelectorContainer button.red--text{
  height: 3rem;
}

.imageSelectorContainer button.red--text:hover{
  color: white !important;
}

</style>
